// theme.js — Datafusion Agency Theme JS
(function () {
  // Mobile menu toggle
  const menuToggle = document.querySelector('.df-header__menu-toggle');
  const mobileNav = document.querySelector('.df-mobile-nav');

  menuToggle?.addEventListener('click', () => {
    mobileNav?.classList.toggle('is-open');
  });

  // Highlight active nav link
  const navLinks = document.querySelectorAll('.df-header__nav-link');
  navLinks.forEach(link => {
    if (link.href === window.location.href) link.classList.add('active');
  });

  // Add-to-cart button feedback
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('.df-product-card__btn');
    if (!btn) return;
    btn.textContent = '✓ AGREGADO';
    btn.classList.add('added');
    setTimeout(() => {
      btn.textContent = '+ AGREGAR AL CARRITO';
      btn.classList.remove('added');
    }, 1500);
  });
})();
